import React from 'react';

export default {
  width: 14,
  height: 14,
  content: (
    <path d="M2 4v8h10V4H2zM0 2h14v12H0V2zM2 0h2v2H2zM10 0h2v2h-2z M4 6h2v1H4zM4 9h2v1H4zM8 6h2v1H8zM8 9h2v1H8z" />
  )
};
